export default __webpack_public_path__ + "static/media/af-50-1.abe9f8b2.png";